<mat-card class="mat-card-flat mat-card-flat--dark">
  <mat-card-header class="mat-card-header--dark">
    <mat-card-title>
      <h1>
        <i class="title-icon title-icon--home"></i>
        My Dashboard
      </h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group mat-stretch-tabs="false"
      class="primary-tab-group mat-tab-content-border"
      [class.mat-tab-first-hidden]="hidePriorAuth"
      [selectedIndex]="selectedTabIndex || redirectToTabIndex" (selectedIndexChange)="selectedTabIndex || (redirectToTabIndex = $event)"
    >
      <mat-tab label="Prior Auth">
        <app-priorauth-queue-component [isInsurerUser]="false"></app-priorauth-queue-component>
      </mat-tab>
      <mat-tab label="Draft eForms">
        <ng-template matTabContent>
          <app-draft-eforms-queue></app-draft-eforms-queue>
        </ng-template>
      </mat-tab>
      <mat-tab label="Submitted eForms">
        <ng-template matTabContent>
          <app-submitted-eforms-queue></app-submitted-eforms-queue>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
